export const UPDATE_SCREEN_RESOLUTION = "UPDATE_SCREEN_RESOLUTION";
export const SHOW_GLOBAL_ERROR = "SHOW_GLOBAL_ERROR";
export const SHOW_GLOBAL_SUCCESSMSG = "SHOW_GLOBAL_SUCCESSMSG";
export const CLEAR_GLOBAL_ERROR = "CLEAR_GLOBAL_ERROR";
export const CLEAR_GLOBAL_SUCCESSMSG = "CLEAR_GLOBAL_SUCCESSMSG";
export const UPDATE_ACTIVE_SCREEN = "UPDATE_ACTIVE_SCREEN";
export const API_LOADING = "API_LOADING";
export const TOGGLE_TECH_SUPPORT_POPUP = "TOGGLE_TECH_SUPPORT_POPUP";
export const SHOW_ACCESS_DENIED_ERROR = "SHOW_ACCESS_DENIED_ERROR";
export const CLEAR_ACCESS_DENIED_ERROR = "CLEAR_ACCESS_DENIED_ERROR";
